import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ArticlesGrid, CategoryTabs } from "@/components/ArticlesGrid";
import { SearchBox } from "@/components/SearchBox";

export default function ArticlesPage() {
  const [params, setParams] = useSearchParams();
  const category = params.get("category") || "all";
  const q = params.get("q") || "";
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  const update = (next) => {
    const p = {};
    const cat = next.category ?? category;
    const query = next.q ?? q;
    if (cat !== "all") p.category = cat;
    if (query) p.q = query;
    setParams(p);
  };

  useEffect(() => {
    document.title = q ? `Search: ${q} | Bharat Gatha` : "Articles | Bharat Gatha";
    setLoading(true);
    api.get("/articles", { params: { category, q: q || undefined, limit: 100 } })
      .then((r) => setArticles(r.data))
      .catch(() => setArticles([]))
      .finally(() => setLoading(false));
  }, [category, q]);

  return (
    <div data-testid="articles-page">
      <Navbar />
      <main className="relative z-10 mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <p className="eyebrow text-[var(--saffron-deep)]">सभी लेख</p>
        <h1 className="mt-3 font-serif text-4xl font-bold tracking-tight text-[var(--chakra-deep)] sm:text-5xl">Articles</h1>
        <p className="mt-4 max-w-2xl text-base text-stone-600 md:text-lg">Essays on the India we inherit and the India we are building.</p>

        <div className="mt-8 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <CategoryTabs value={category} onChange={(v) => update({ category: v })} />
          <SearchBox value={q} onChange={(v) => update({ q: v })} autoFocus={!!q} className="w-full lg:w-96" />
        </div>

        {q && !loading && (
          <p className="mt-6 text-sm text-stone-600" data-testid="search-results-summary">
            {articles.length} result{articles.length === 1 ? "" : "s"} for <span className="font-semibold text-[var(--chakra-deep)]">"{q}"</span>
          </p>
        )}

        <div className="mt-8">
          <ArticlesGrid articles={articles} loading={loading} emptyMessage={q ? `Nothing found for "${q}". Try a different word, tag or state.` : undefined} />
        </div>
      </main>
      <Footer />
    </div>
  );
}
